import React from 'react';
import propTypes from 'prop-types';
export const RoomIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      fill={color}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={sizeInPixel}
      height={sizeInPixel}
      viewBox="0 0 45.945 45.945"
      xmlSpace="preserve"
    >
      <g>
        <path
          d="M41.034,23.817l-1.539-1.122c-0.104-0.074-0.226-0.115-0.353-0.119l-2.889-0.071c-0.253-0.006-0.478-0.165-0.567-0.402
       l-1.065-2.833c-0.043-0.112-0.118-0.212-0.216-0.283l-2.188-1.594c-0.103-0.075-0.225-0.117-0.352-0.12l-2.889-0.068
       c-0.251-0.007-0.476-0.164-0.565-0.398l-1.105-2.87c-0.043-0.111-0.117-0.208-0.214-0.278l-3.209-2.339
       c0.429-3.73-1.238-7.557-4.615-9.717C14.543-1.421,8.265-0.042,5.243,4.68C2.222,9.404,3.612,15.683,8.333,18.703
       c0.438,0.281,0.906,0.522,1.362,0.729v1.5H7.932c-0.778,0-1.5,0.417-1.9,1.085l-2.03,3.396c-0.207,0.345-0.312,0.743-0.312,1.146
       v17.144c0.001,1.223,0.984,2.243,2.208,2.243h11.547c1.224,0,2.211-1.021,2.211-2.244V26.586c0-0.399-0.106-0.796-0.311-1.14
       l-2.036-3.423c-0.4-0.671-1.123-1.091-1.903-1.091h-1.757v-0.629c1.901,0.022,3.788-0.487,5.42-1.479L37.609,29.16
       c1.424,0.794,3.223,0.344,4.102-1.029l0.103-0.159C42.693,26.598,42.351,24.777,41.034,23.817z M14.581,25.258
       c0,1.612-1.303,2.92-2.915,2.92c-1.612,0-2.905-1.308-2.905-2.92c0-0.839,0.327-1.597,0.935-2.128v0.839
       c0,1.103,0.874,1.997,1.977,1.997c1.104,0,1.977-0.896,1.977-1.997V23.13C14.258,23.661,14.581,24.419,14.581,25.258z
        M14.936,10.89c-0.335,0.523-0.754,0.938-1.286,1.238V9.985c0-1.103-0.873-1.997-1.977-1.997c-1.103,0-1.977,0.895-1.977,1.997
       v2.142c-0.076-0.021-0.076-0.038-0.108-0.059C7.779,10.91,7.246,8.507,8.403,6.7c1.157-1.811,3.553-2.337,5.362-1.18
       C15.574,6.677,16.093,9.083,14.936,10.89z"
        />
      </g>
    </svg>
  );
};
RoomIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
RoomIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
